// extracted by mini-css-extract-plugin
export default {"income_wrapper":"Income_income_wrapper__Evpm2","heading_area":"Income_heading_area__wkf9s","heading":"Income_heading__8IYTH","sub_heading":"Income_sub_heading__YhWIO"};